import { render, staticRenderFns } from "./UploadFingerprintSingle.vue?vue&type=template&id=0a83659a&scoped=true&"
import script from "./UploadFingerprintSingle.vue?vue&type=script&lang=js&"
export * from "./UploadFingerprintSingle.vue?vue&type=script&lang=js&"
import style0 from "./UploadFingerprintSingle.vue?vue&type=style&index=0&id=0a83659a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a83659a",
  null
  
)

export default component.exports